export function isPublicCertificatePath(pathname) {
  try { return /^\/справка(?:\/|$)/i.test(decodeURI(pathname || '')) } catch (_) { return false }
}
